import React from "react";

const ImageComponent = ({ width, height, src, alt, fit, bgColor, attributes, children, layout = "intrinsic" }) => {
  /**
   * @type {React.CSSProperties}
   */
  const style = {
    objectFit: fit || "contain",
    backgroundColor: bgColor || "transparent",
    width: "100%",
    maxWidth: "100%",
  };

  return (
    <div style={{ padding: 8, backgroundColor: "#fafafa" }}>
      <div
        className="yoo-image-w-full yoo-image-relative yoo-image-overflow-hidden yoo-image-border yoo-image-border-gray-300 yoo-image-rounded-md yoo-image-p-2 yoo-image-bg-white"
        data-layout={layout}
        {...attributes}
      >
        {src && (
          <img
            src={src}
            width={width - 16}
            height={height - 16}
            alt={alt || ""}
            decoding="async"
            loading="lazy"
            style={style}
          />
        )}
        {children}
        {alt && (
          <div className="yoopta-image-alt" title={alt}>
            <div className="yoopta-image-alt-text">ALT</div>
          </div>
        )}
      </div>
    </div>
  );
};

export { ImageComponent };
